import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'
import { EXPENSE_COMPOSITION_GRANULARITIES } from './granularity'

export const expenseCompositionItemSchema = z.object({
  // either a real category uuid or the literal `'uncategorized'` sentinel
  // used for shared-expense leftovers where the viewer cannot see the per-split category.
  id: z.string(),
  name: z.string(),
  color: z.string().nullable(),
  icon: z.string().nullable(),
  // one entry per bucket, index-aligned with `buckets`
  values: z.array(z.number()),
  total: z.number(),
  bucketAverage: z.number(),
})

export type ExpenseCompositionItemDto = z.infer<typeof expenseCompositionItemSchema>

export const expenseCompositionResponseSchema = z.object({
  baseCurrency: z.nativeEnum(Currency),
  range: z.object({
    from: z.string(),
    to: z.string(),
  }),
  granularity: z.enum(EXPENSE_COMPOSITION_GRANULARITIES),
  /**
   * Bucket keys, ascending. Shape depends on `granularity`:
   * `day`/`week` → `YYYY-MM-DD` (week = the bucket's Monday), `month` → `YYYY-MM`, `year` → `YYYY`.
   */
  buckets: z.array(z.string()),
  categories: z.array(expenseCompositionItemSchema),
  bucketTotals: z.array(z.number()),
  rangeBucketAverage: z.number(),
  skippedExpenseCount: z.number().int().nonnegative(),
})

export type ExpenseCompositionResponseDto = z.infer<typeof expenseCompositionResponseSchema>
